import { caseInsensitiveFilter } from 'Common/GridHelper';

export const Config = {
  minRows: 2,
  defaultFilterMethod: caseInsensitiveFilter,
  className: '-striped -highlight',
  resizable: false,
};

export const DefaultColumnKeysSaved = [
  'Header',
  'show',
  'visibility',
  'accessor',
];

export const DefaultTableState = Object.freeze({
  filtered: [],
  sorted: [],
  pageSize: 20,
  page: 0,
  lockedColumns: {},

  // saves DefaultColumnKeysSaved, order is determined by array index
  columns: [],
});

export const ReactTablePropNameEnum = {
  filtered: 'filtered',
  sorted: 'sorted',
  pageSize: 'pageSize',
  page: 'page',
  lockedColumns: 'lockedColumns',
  columns: 'columns',
};

export const REACT_TABLE_ROW_COLORS = {
  INACTIVE: 'red',
  USED_ON_MENU: 'blue',
};

export const HeaderLeftAlign = {
  headerStyle: {
    textAlign: 'left',
  },
};


// WEBPACK FOOTER //
// ./src/common/Constants/table.js